var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGoogleMapsDot = function SvgGoogleMapsDot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.738,
    height: 13.694
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "googleMapsDot_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242423",
    d: "M0 0h11.738v13.694H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#googleMapsDot_svg__a)",
    fill: "#242423"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.283 13.353-.414.341-.414-.341C1.838 10.377 0 8.043 0 5.869a5.869 5.869 0 0 1 11.738 0c0 2.174-1.838 4.509-5.455 7.484m4.15-7.484a4.565 4.565 0 1 0-9.129 0c0 1.6 1.5 3.54 4.564 6.131 3.061-2.591 4.565-4.534 4.565-6.131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.868 8.477a2.608 2.608 0 1 1 2.608-2.608 2.608 2.608 0 0 1-2.608 2.608m0-1.3a1.3 1.3 0 1 0-1.3-1.3 1.3 1.3 0 0 0 1.3 1.3"
  }))));
};

export default SvgGoogleMapsDot;